import PaginatedResponse from '../base/paginatedResponse'
import { ObjectType } from '@nestjs/graphql'
import { PenNameDto } from './model.dto'

@ObjectType()
export class PenNamePagedResultDto extends PaginatedResponse(PenNameDto) {
}
